<template>
  <div class="p-d-flex p-flex-column">
    <a :href="link">
      <p-vue-button
        :class="{
          submit: true,
          'p-button': true,
          'p-button-lg': true,
          'p-button-success': true,
          'p-button-rounded': true,
        }"
      >
        <span>{{ __("Downloading an app") }}</span>
      </p-vue-button>
    </a>
    <a>
      <p-vue-button
        :class="{
          submit: true,
          'p-button': true,
          'p-button-lg': true,
          'p-button-success': true,
          'p-button-rounded': true,
        }"
        @click="continueInBrowser"
      >
        {{ __("Browsing a website") }}
      </p-vue-button>
    </a>

    <div class="p-d-flex p-ai-center p-jc-center" style="margin-right:8px">
      <p-vue-checkbox :binary="true" v-model="dontShowAgain" />
      <label class="checkBoxDesign">
        {{ __("Do not show this message again") }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["continueInBrowser"],
  props: ["continueText"],
  data() {
    return {
      androidLink:
        "https://play.google.com/store/apps/details?id=com.apoint.tenantapp",
      iphoneLink: "https://apps.apple.com/app/build-app/id1605492474",
      link: null,
      dontShowAgain: null,
    };
  },
  mounted() {
    if (window.cordova.platformId == "android") this.link = this.androidLink;
    else this.link = this.iphoneLink;
  },
  methods: {
    continueInBrowser() {
      if (this.dontShowAgain)
        this.$cookie.setCookie("continueInBrowser", new Date());
      this.$emit("continueInBrowser");
    },
  },
};
</script>

<style scoped>
a {
  margin-bottom: 25px;
  color: black;
  font-size: 16px;
  font-weight: 500;
  text-decoration: unset;
  display: flex;
}

.submit {
  display: block;
  width: 100%;
  font-weight: bold;
}

.checkBoxDesign {
  margin-right: 10px;
}
</style>
